export default function PdfViewModal() {
  return null;
}
